import { render, staticRenderFns } from "./ManagedApnService.vue?vue&type=template&id=2478c57b&"
import script from "./ManagedApnService.vue?vue&type=script&lang=js&"
export * from "./ManagedApnService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports